import queryKeys from '@/constants/queryKeys';
import { getBoardNameAndColumns } from '@/services/board';
import { Column } from '@mondaydotcomorg/api-types';
import { useQuery, UseQueryResult } from 'react-query';

interface IBoardNameAndColumns {
  id: number;
  name: string;
  columns: Pick<Column, 'id' | 'title' | 'type' | 'settings_str'>[];
}

export const useGetBoardNameAndColumnsQuery = (
  boardId: number,
): UseQueryResult<IBoardNameAndColumns> => {
  return useQuery(
    [queryKeys.MONDAY_GET_BOARD_COLUMNS, boardId],
    () => getBoardNameAndColumns(boardId),
    { select: (response) => response?.data?.boards?.[0] },
  );
};
